import { render, staticRenderFns } from "./RiskReportBasis.vue?vue&type=template&id=49fb8b8a&scoped=true&"
import script from "./RiskReportBasis.vue?vue&type=script&lang=js&"
export * from "./RiskReportBasis.vue?vue&type=script&lang=js&"
import style0 from "./RiskReportBasis.vue?vue&type=style&index=0&id=49fb8b8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb8b8a",
  null
  
)

export default component.exports